import React from 'react';
import styled from 'styled-components';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import { FILTER_ERROR } from '@components/summary-panel/FilterDropdown/FilterStatus';

const ErrorIcon = styled(ExclamationCircleOutlined)`
  color: #ff2f36;
  margin-left: 2px;
`;

const FilterError = () => {
  return (
    <Tooltip placement="right" title={FILTER_ERROR}>
      <ErrorIcon />
    </Tooltip>
  );
};

export default FilterError;
